// src/App.js
import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

import ArchiveHandshake from './screens/ArchiveHandshake';
import './union-terminal.css';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/*" element={<ArchiveHandshake />} />
      </Routes>
    </Router>
  );
}

export default App;
